import {setPrimerPosRequestData, setSelectedPrimerPosList} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import DateBox from "../../../../primer/DateBox";
import moment from "moment/moment";
import DateTimeBox from "../../../../primer/DateTimeBox";
import Input from "../../../../common/Input";
import {FaCheck} from "react-icons/fa";
import {MdCancel} from "react-icons/md";
import axios from "axios";
import {toast} from "react-toastify";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import {openPrimerPOSReport, openSale} from "../../../../../_helpers/tabOpeners";

const PrimerPosListModal = () => {
    const dispatch = useDispatch();
    const isMobileScreen = useMediaQuery("(max-width: 768px)");
    const company = useSelector(state => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const requestData = useSelector((state) => state.CLIENTS_DATA.primerPosRequestData);
    const selectedList = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPosList);
    const [printLoader, setPrintLoader] = useState(false);
    const [completeLoader, setCompleteLoader] = useState(false);
    const [errorLog, setErrorLog] = useState([]);

    useEffect(() => {
        if(selectedList?.print) {
            printAcsList();
        }
    }, [selectedList?.print]);

    const statusOptions = [
        {value: "pending", label: "Εκκρεμής", color: "#fff5bd"},
        {value: "completed", label: "Ολοκληρωμένη", color: "#b1fcb1"},
        {value: "cancelled", label: "Ακυρωμένη", color: "#ffcfcf"},
    ];

    const printAcsList = () => {
        if(!isEmpty(selectedList?.acsListId) && !isEmpty(selectedList?.shippingDate)) {
            setPrintLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-acs-list", {action: "print", acsListId: selectedList.acsListId, shippingDate: selectedList?.shippingDate}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    toast.success(res.data.message);
                    printBase64Pdf(res.data.data);
                } else {
                    toast.error(res.data.message);
                }
                setPrintLoader(false);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setPrintLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!");
        }
        dispatch(setSelectedPrimerPosList({...selectedList, print: false}));
    }

    const printBase64Pdf = (base64String) => {
        const blob = new Blob([Uint8Array.from(atob(base64String), c => c.charCodeAt(0))], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        iframe.onload = () => {
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 100);
        };
        document.body.appendChild(iframe);
    };

    const completeAcsList = () => {
        if(!isEmpty(selectedList?._id)) {
            setCompleteLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-complete-list", {_id: selectedList._id}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    toast.success(res.data.message);
                    dispatch(setSelectedPrimerPosList(res.data.data));
                    if(res.data?.errorLog?.length > 0) setErrorLog(res.data.errorLog);
                } else {
                    toast.error(res.data.message);
                }
                setCompleteLoader(false);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setCompleteLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!");
        }
    }

    const handleOpenSale = (saleId) => {
        if (saleId) {
            openSale(dispatch, TABS_DATA, company.id, saleId);
        }
    }

    return (
        <React.Fragment>
            <Modal backdrop={"static"} className="themeModalBig" show={!isEmpty(selectedList)} onHide={() => dispatch(setSelectedPrimerPosList(null))}>
                <Modal.Header closeButton>
                    <Modal.Title>Λίστα Αποστολής ACS ({selectedList?.acsListId})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className={"mb-2"}>
                        <Col md={3}>
                            <Input
                                name="acsListId"
                                label="Αναγνωριστικό Λίστας"
                                autoComplete="off"
                                disabled={true}
                                value={selectedList?.acsListId}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name="status"
                                label="Κατάσταση Λίστας"
                                autoComplete="off"
                                disabled={true}
                                value={statusOptions.find((el) => el.value === selectedList?.status)?.label}
                            />
                        </Col>
                        <Col md={3}>
                            <DateTimeBox
                                classes="w-100"
                                label={"Ημερομηνία και Ώρα Δημιουργίας"}
                                name="created_at"
                                disabled={true}
                                selected={moment(selectedList?.created_at).toDate()}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name="createdBy"
                                label="Χρήστης Δημιουργίας"
                                autoComplete="off"
                                disabled={true}
                                value={selectedList?.createdBy}
                            />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={3}>
                            <DateBox
                                label={"Ημερομηνία Αποστολής"}
                                name="shippingDate"
                                disabled={true}
                                minDate={moment().toDate()}
                                selected={(moment(selectedList?.shippingDate).isValid() && !isEmpty(selectedList?.shippingDate)) ? moment(selectedList?.shippingDate).toDate() : null}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name="vouchers"
                                label="Πλήθος Voucher"
                                autoComplete="off"
                                disabled={true}
                                value={selectedList?.vouchers?.length || 0}
                            />
                        </Col>
                        <Col md={3}>
                            <DateTimeBox
                                label={"Ημερομηνία Ολοκλήρωσης"}
                                name="completedDate"
                                disabled={true}
                                minDate={moment().toDate()}
                                selected={(moment(selectedList?.completedDate).isValid() && !isEmpty(selectedList?.completedDate)) ? moment(selectedList?.completedDate).toDate() : null}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name="completedBy"
                                label="Χρήστης Ολοκλήρωσης"
                                autoComplete="off"
                                disabled={true}
                                value={selectedList?.completedBy || " "}
                            />
                        </Col>
                    </Row>
                    <hr />
                    <div style={{maxHeight: isMobileScreen ? "60vh" : "70vh", overflowY: 'auto', overflowX: isMobileScreen? 'auto' : 'hidden'}}>
                        <Row style={{overflowX: "auto"}}>
                            <Col md={12}>
                                <table className={"simpleClassicTable clientMovementsReportTable mt-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "2%"}}></col>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "2%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                        <col span={1} style={{width: "6%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th style={{border: "1px solid gray"}}>A/A</th>
                                        <th style={{border: "1px solid gray"}}>Κωδικός Voucher</th>
                                        <th style={{border: "1px solid gray"}}>Πελάτης</th>
                                        <th style={{border: "1px solid gray"}}>Τόπος Παράδοσης</th>
                                        <th style={{border: "1px solid gray"}}>Πλήθος Συσκευών</th>
                                        <th style={{border: "1px solid gray"}}>Συσκευές</th>
                                        <th style={{border: "1px solid gray"}}>Ενέργειες</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {selectedList?.vouchers?.map((row, idx) => {
                                        return (
                                            <tr key={`posListTable-${idx}`} style={{height: "45px", backgroundColor: !isEmpty(row?.saleId) ? "#b1fcb1" : !isEmpty(row?.error) ? "#ffcfcf" : row["serials"]?.length > 1 ? "#fff5bd" : "white"}}>
                                                <td style={{border: "1px solid gray"}}>
                                                    {row?.checked ? <FaCheck size={15} color={"green"} /> : ""}
                                                    {row?.notFound ? <MdCancel size={15} color={"red"} /> : ""}
                                                    {" "}
                                                    {idx + 1}</td>
                                                <td style={{border: "1px solid gray"}}>
                                                    {row["acsVoucher"]}
                                                    {!isEmpty(row?.acsMultipartVouchers) && row?.acsMultipartVouchers?.length > 0 && (
                                                        <span>{` (Συνοδευτικά: ${row.acsMultipartVouchers.join(", ")})`}</span>
                                                    )}
                                                </td>
                                                <td style={{border: "1px solid gray"}}>{row["client"]}</td>
                                                <td style={{border: "1px solid gray"}}>{row["address"]}</td>
                                                <td style={{border: "1px solid gray"}}>{row["quantity"]}</td>
                                                <td style={{border: "1px solid gray"}}>{row["serials"].join(', ')}</td>
                                                <td style={{border: "1px solid gray", padding: "5px"}}>
                                                    <div className="d-flex justify-content-between">
                                                    <Button style={{padding: "5px", marginRight: "5px"}} variant="primary" onClick={() => {
                                                        dispatch(setPrimerPosRequestData({...requestData, acsVoucher: row.acsVoucher, remote: true}));
                                                        dispatch(openPrimerPOSReport(TABS_DATA));
                                                    }}>
                                                        Εμφάνιση Συσκευών
                                                    </Button>
                                                        {(!isEmpty(row?.saleId) || !isEmpty(row?.error)) && (
                                                            <Button style={{padding: "5px", marginLeft: "5px"}} variant={"primary"} onClick={() => {
                                                                if(!isEmpty(row?.saleId)) {
                                                                    handleOpenSale(row?.saleId);
                                                                } else if(!isEmpty(row?.error)) {
                                                                    setErrorLog([row.error]);
                                                                }
                                                            }}>
                                                                {!isEmpty(row?.saleId) ? "Εμφάνιση Παραστατικού" : "Εμφάνιση Σφάλματος"}
                                                            </Button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )})}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{justifyContent: 'initial'}}>
                    <div style={{flex: 1, justifyContent: 'flex-start'}}>
                        <Button style={{float: 'left'}} variant="outline-primary" onClick={() => dispatch(setSelectedPrimerPosList(null))}>
                            Κλείσιμο
                        </Button>
                    </div>
                    <Button disabled={printLoader} variant="primary" onClick={() => dispatch(setSelectedPrimerPosList({...selectedList, print: true}))}>
                        {"Εκτύπωση Λίστας "}
                        {printLoader && (<span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>)}
                    </Button>
                    {selectedList?.status !== "completed" && selectedList?.status !== "cancelled" && (
                        <Button disabled={completeLoader} variant="primary" onClick={() => completeAcsList()}>
                            {"Ολοκλήρωση Λίστας και Έκδοση Παραστατικών "}
                            {completeLoader && (<span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>)}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
            <Modal backdrop={"static"} className="themeModalSemiMedium" show={errorLog?.length > 0} onHide={() => setErrorLog([])}>
                <Modal.Header closeButton>
                    <Modal.Title>Αρχείο καταγραφής σφαλμάτων Λίστας Αποστολής ACS ({selectedList?.acsListId})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bg-light w-100 border p-3">
                        {errorLog.map(e => <React.Fragment><p>{e}</p> <hr /></React.Fragment>)}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setErrorLog([])}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default PrimerPosListModal;